import React from "react";
import Pill from "./PillElement";

export const BasicTemplatePill = () => {
  return <Pill
    color="purple"
    label={RESX.MessageTemplate.BasicTemplate}
  />
}